import { IFormValues } from '~/ui/components/reusable/ActivityLogOfflineForm/types';

const initialValues: IFormValues = {
  dateTime: '',
  minutesSpent: null,
  note: '',
};

export default initialValues;
